import React, { useEffect } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { isAdmin } from "../Utils/functions";
import EntriesManagement from "./EntriesManagement";
import FieldsManagement from "./FieldsManagement";
import GalleryManagement from "./GalleryManagement";

const Admin = (props) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  // Redirect to home if not admin
  useEffect(() => {
    if (!loading && !isAdmin(user)) {
      navigate("/");
    }
  }, [user, loading, navigate]);

  // Show nothing while checking or redirecting
  if (loading || !isAdmin(user)) {
    return null;
  }

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", boxSizing: "border-box", overflow: "hidden" }}>
      <Paper 
        elevation={0}
        sx={{ 
          width: "100%", 
          maxWidth: "100%", 
          boxSizing: "border-box", 
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3, flexShrink: 0 }}>
          <Tabs 
            value={currentTab} 
            onChange={handleTabChange}
            sx={{
              minHeight: 48,
              "& .MuiTab-root": {
                textTransform: "none",
                minHeight: 48,
                fontWeight: 400,
              },
              "& .MuiTabs-indicator": {
                height: 2,
              }
            }}
          >
            <Tab label="Entries" />
            <Tab label="Fields" />
            <Tab label="Gallery" />
            {/* Add more tabs here as needed */}
          </Tabs>
        </Box>
        <Box sx={{ padding: 3, boxSizing: "border-box", width: "100%", maxWidth: "100%", overflow: "hidden", flex: 1 }}>
          {currentTab === 0 && <EntriesManagement />}
          {currentTab === 1 && <FieldsManagement />}
          {currentTab === 2 && <GalleryManagement />}
        </Box>
      </Paper>
    </Box>
  );
};

export default Admin;
